import { render, staticRenderFns } from "./jumpQwQy.vue?vue&type=template&id=31afdc7c&scoped=true"
import script from "./jumpQwQy.vue?vue&type=script&lang=js"
export * from "./jumpQwQy.vue?vue&type=script&lang=js"
import style0 from "./jumpQwQy.vue?vue&type=style&index=0&id=31afdc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31afdc7c",
  null
  
)

export default component.exports